module.exports = __webpack_public_path__ + "static/media/food-icon.1780f9f8.svg";